import { useSelector } from 'react-redux';
import { addHomeData, homeDataSelector } from '../Redux/appStateSlice';
import { WithFetchJsonContent } from './WithFetchJsonContent';

export const WithHomeData = ({ children }) => {
  const homeData = useSelector(homeDataSelector);

  return (
    <WithFetchJsonContent
      reduxInStore={homeData}
      addToReduxFunction={addHomeData}
      jsonLocation="content/homepageColumns"
    >
      {children}
    </WithFetchJsonContent>
  );
};
